var React = require('react');

function Nist (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","d":"M45 0C20 0 0 20 0 45v125h40V45c0-4 5-6 8.5-3.5l104.9 115.1c29 29 77 8 77-31V-.4h-40v126c0 4-5 6-8.3 3.5L77.6 14.1c-10-10-18-14-32.5-14M250.2 0v125a45 45 0 0 0 45 45H463a52.5 52.5 0 0 0 0-105H357.8a12.5 12.5 0 0 1 0-25h177.5v130h40V40h70V0H357.8a52.5 52.5 0 0 0 0 105h105a12.5 12.5 0 0 1 0 25H295.3a5 5 0 0 1-5-5V0z"}));
}

Nist.defaultProps = {"width":"646","height":"170.3","viewBox":"0 0 646 170.3","version":"1.0"};

module.exports = Nist;

Nist.default = Nist;
